import { useState } from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { useT } from "@/lib/labels";

const KEY = "lk_cookie_notice_ok";

export const CookieBanner = () => {
  const { settings } = useSite();
  const t = useT();
  const [ok, setOk] = useState(() => localStorage.getItem(KEY) === "1");
  if (!settings.legal_enabled || ok) return null;
  const accept = () => { localStorage.setItem(KEY, "1"); setOk(true); };
  return (
    <div data-testid="cookie-banner" role="region" aria-label="Cookie notice"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#1a120c] text-[#f4efe2] border-t-2 border-[#c9a227] shadow-[0_-8px_30px_rgba(0,0,0,0.35)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <p data-testid="cookie-banner-text" className="flex-1 text-sm leading-relaxed">
          {t("cookie.text")} <Link to="/legal/privacy" data-testid="cookie-banner-privacy" className="underline text-[#e6bb45]">{t("cookie.link")}</Link>
        </p>
        <button data-testid="cookie-banner-ok" onClick={accept} className="btn-illum theme-flame justify-center shrink-0">{t("cookie.ok")}</button>
      </div>
    </div>
  );
};
